import React, { Component } from 'react'
import { Tab, Tabs, TabList } from 'react-tabs'

class Wizard extends Component {
  constructor (props) {
    super(props)
    this.state = {
      tabIndex: 0
    }
  }
  componentWillReceiveProps (props) {
    if (props.tabIndex !== this.props.tabIndex) this.setState({tabIndex: props.tabIndex})
  }
  handleTabIndex (index) {
    this.setState({tabIndex: index})
    this.props.changeTabIndex(index)
  }
  render () {
    return (
      <div className='wizard-wrapper col-md-12'>
        <div className='wizard-body'>
          <Tabs selectedTabClassName='current-tab' onSelect={() => {}} selectedIndex={this.state.tabIndex}>
            <div className='wizard-buttons-container'>
              <TabList className='wizardtabs'>
                {this.props.buttons && this.props.buttons.map((button, index) => {
                  if (button.hidden) return
                  return (
                    <Tab key={'Wizard_tab_' + index} className='wizard-tab' onClick={() => (button.noClick ? '' : this.handleTabIndex(this.props.buttons.indexOf(button)))} data-tip={button.tip}>
                      <a><i className={'fa fa-fw ' + button.icon + (button.disabled ? ' icon-disabled' : '')} /></a>
                    </Tab>
                  )
                })}
              </TabList>
            </div>
            <div className={'wizard-content ' + this.props.className}>
              {this.props.children}
            </div>
          </Tabs>
        </div>
      </div>
    )
  }
}
export default Wizard



// WEBPACK FOOTER //
// ./src/components/basic/containers/Wizard.js